import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import Filter from "../../../components/reports/visits/Filter";
import List from "../../../components/reports/visits/List";
import { AuthContext } from "../../../context/auth";
import api from "../../../services/api";
import { Translate } from "../../../translate";
import { findPath } from "../../../util/location";
import { messageError } from "../../../util/messages";
import { datetimeSort, toDateLocalNow, toDateLocalToday } from "../../../util/time";

const Visits = () => {
  const { environment } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [range, setRange] = useState([
    toDateLocalToday(),
    toDateLocalNow(),
  ]);

  const fetchLocations = () => {
    api
      .get("/maintenance/location/tree/", { params: { disabled: true } })
      .then((response) => {
        setLocations(response.data);
      })
      .catch((error) => messageError(error));
  };

  const search = async (values) => {
    try {
      setLoading(true);
      let { data } = await api.get("/control/event/group/local/type", {
        params: values,
      });
      let _range = datetimeSort(range[0]) + "-" + datetimeSort(range[1]);
      if (data && data.length > 0) {
        data.forEach((element) => {
          element.range = _range;
          let location = findPath(locations, element.locationId);
          if (location) element.location = location;
        });
      }
      setData(data);
    } catch (error) {
      messageError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, [environment]);

  return (
    <>
      <Row>
        <Col xs={24}>
          <span className="text-title primary-text-color">
            {Translate.t("menu.visits")}
          </span>
        </Col>
        <Col xs={24} style={{ marginTop: "10px" }}>
          <span className="text-sub secondary-text-color">
            {Translate.t("title.info.visits")}
          </span>
        </Col>
      </Row>
      <Filter
        search={search}
        loading={loading}
        data={data}
        locations={locations}
        range={range}
        setRange={setRange}
      />
      <List search={search} data={data} loading={loading} />
    </>
  );
};

export default Visits;
